import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Checkbox, FormControlLabel, Grid, InputLabel, OutlinedInput } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import React, { useEffect, useRef } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DefaultUploadFile from "../../../components/default-upload-file";
import { useCadastrosBasicoDispatch, useCadastrosBasicoState } from "../context/cadastros-basico-context";
import { useCadastrosBasicoController } from "../context/cadastros-basico-controller";
import { ACTION_TYPES, FORM_TYPES } from "../context/cadastros-basico-reducer";

export const BannerForm = () => {
    const { dataRequest, file } = useCadastrosBasicoState();
    const cadastrosBasicoDispatch = useCadastrosBasicoDispatch();
    const { handleOnChangeForm } = useCadastrosBasicoController();
    const firstInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);
    
    return (
        <React.Fragment>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid container spacing={2}>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xl={12}
                    >
                        <InputLabel>Titulo</InputLabel>
                        <OutlinedInput
                            ref={firstInputRef}
                            size="small"
                            inputProps={{ min: 0 }}
                            error={dataRequest?.title === undefined || dataRequest?.title.length === 0 ? true : false}
                            name="input-title"
                            value={dataRequest?.title}
                            defaultValue={dataRequest?.title}
                            onChange={(e) => handleOnChangeForm(FORM_TYPES.banners, e)}
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xl={12}
                    >
                        <InputLabel>Subtitulo</InputLabel>
                        <OutlinedInput
                            size="small"


                            inputProps={{ min: 0 }}
                            name="input-subtitle"
                            value={dataRequest?.subtitle}
                            defaultValue={dataRequest?.subtitle}
                            onChange={(e) => handleOnChangeForm(FORM_TYPES.banners, e)}
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xl={12}
                    >
                        <InputLabel>Url (http)</InputLabel>
                        <OutlinedInput
                            size="small"
                            inputProps={{ min: 0 }}
                            name="input-url"
                            value={dataRequest?.url}
                            defaultValue={dataRequest?.url}
                            onChange={(e) => handleOnChangeForm(FORM_TYPES.banners, e)}
                            fullWidth

                        />
                    </Grid>
                    <Grid
                        item
                        lg={4}
                        sm={4}
                        xl={4}
                    >
                        <InputLabel>Data da Publicação</InputLabel>
                        <DesktopDatePicker minDate={dayjs()}

                            format='DD/MM/YYYY'
                            slotProps={{ textField: { fullWidth: true, size: "small", error: dataRequest?.publication === undefined || dataRequest?.publication.length === 0 ? true : false } }}

                            value={dataRequest?.publication != null ? dayjs(dataRequest?.publication) : null}
                            onChange={(value: Dayjs | null) => {
                                let publication = value?.format("YYYY-MM-DD");
                                cadastrosBasicoDispatch({
                                    type: ACTION_TYPES.setDataRequest,
                                    payload: { ...dataRequest, publication },
                                });
                            }}

                        />

                    </Grid>
                    <Grid
                        item
                        lg={4}
                        sm={4}
                        xl={4}
                        direction="column"
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                    <FormControlLabel          name="chk-published"   onChange={(e) => handleOnChangeForm(FORM_TYPES.banners, e)} control={<Checkbox defaultChecked={dataRequest?.published} />} label="Publicado" />
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xl={12}
                    >
                        <InputLabel>Imagem do Banner</InputLabel>
                        <DefaultUploadFile
                            setFileUpload={(file) => {
                                cadastrosBasicoDispatch({
                                    type: ACTION_TYPES.setFile,
                                    payload: file
                                });
                            }}
                            file={file}
                            id="input"
                            extensions={["jpg", "jpeg", "png"]}
                            maxFileSizeMb={10}
                            existingImageUrl={dataRequest?.imageUrl}
                        />
                    </Grid>
                </Grid>
            </LocalizationProvider>
        </React.Fragment>
    );
}